import { Form, Select } from 'antd';
import React from 'react';
import { CompWithFormProp } from '../../constants/constants';
import { supLevels } from '../../constants/sup';
import { selectHerePlaceholder } from '../../constants/translations';

export const SupLevelSelector = React.memo(({ form }: CompWithFormProp) => {
  const selectedGrade = Form.useWatch(
    ['registration', 'selectedSubject'],
    form,
  );

  return (
    <Form.Item
      label="SUP lygis"
      name={['registration', 'supLevel']}
      style={{ display: selectedGrade ? 'block' : 'none' }}
    >
      <Select placeholder={selectHerePlaceholder} showSearch={true}>
        {supLevels.map((item, index) => (
          <Select.Option key={`selector_item_${index + 1}`} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
});
